import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { ELinenStatus, getLinenStatus } from '@/redux/selectors/listing/amenities';

export interface ILinenItem {
  label: string;
  unavailable: boolean;
}

const messages = defineMessages({
  [ELinenStatus.Included]: {
    defaultMessage: 'Linens included',
    description: 'listing/amenities: pinned linen row — linens included',
    id: 'mEBSjZ',
  },
  [ELinenStatus.Addon]: {
    id: 'rnL+Xs',
    defaultMessage: 'Linens available',
    description: 'listing/amenities: pinned linen row — linens available as paid add-on',
  },
});

export function useLinenItem(): ILinenItem | null {
  const intl = useIntl();
  const linenStatus = useSelector(getLinenStatus);

  return useMemo(() => {
    if (linenStatus == null || linenStatus === ELinenStatus.NotIncluded) {
      return null;
    }

    return {
      label: intl.formatMessage(messages[linenStatus]),
      unavailable: false,
    };
  }, [intl, linenStatus]);
}
